export default {
  copyright: 'COPYRIGHT © {renderHostName} 版权所有 RESERVED',
  homePage: '进入官网',
  download: 'APP下载',
  register: '立即注册',
  service: '在线客服',
  close: '关闭',
  enter: '立即进入',
};
